import ApiUtils from "./api/ApiUtils";

export const checkUserExists = async () => {
    const currentUserId=JSON.parse(localStorage.getItem('user'))?.userId
    
      const res = await ApiUtils.getUserById(currentUserId);
      const isActive = res?.data?.data?.status;
      return isActive
  };
  